import { useEffect } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { getUserDetails } from '../../../actions/userActions'
import HelpTooltip from '../../Tooltip/HelpTooltip'

interface UserDetailsProps {
  userId?: string
}

const UserDetails = ({ userId }: UserDetailsProps) => {
  const dispatch = useDispatch()
  const { project } = useSelector((state: RootStateOrAny) => state.projectDetails)
  const { user } = useSelector((state: RootStateOrAny) => state.userDetails)

  useEffect(() => {
    if (project.user || userId) {
      dispatch(getUserDetails(userId ? userId : project.user))
    }
  }, [dispatch, project, userId])

  return (
    <>
      for {user.firstName} {user.lastName}{' '}
      <HelpTooltip
        title={
          <div className="p-b-12">
            <p className="fs12">
              <strong>Contact information</strong>
            </p>
            <p className="fs12 m-b-0">Email: {user.email}</p>

            {user.phone && <p className="fs12 m-b-0">Phone: {user.phone}</p>}
            {user.company && user.company.companyName && (
              <p className="fs12 m-b-0">Company: {user.company.companyName}</p>
            )}
          </div>
        }
      />
    </>
  )
}

export default UserDetails
